<template>
<header-middle />
<div class="container py-4 text-center">
    <h2 class="mb-1">پیگیری سفارش</h2>
    <p class="mb-0 r-text-start r-pr-1">در همین صفحه به صورت آنلاین سفارشتان را پیگیری کنید</p>
    <div class="alert alert-info mt-2">
        <div class="d-flex justify-content-around">
            <div class="d-flex">
              <div>شناسه پیگیری : </div>
              <div>{{convertToPersian(String(logCode))}}</div>
            </div>

            <div class="d-flex">
              <div>{{convertToPersian(String(orderDate))}}</div>
            </div>
        </div>
        <hr/>
        <div class="d-flex justify-content-around">
          <div class="d-flex" data-bs-toggle="offcanvas" data-bs-target="#offcanvasOrderItems" >
            <div>جزئیات سفارش </div>
            <div><i class="fa fa-chevron-down"></i></div>
          </div>
            <div @click="goSupport" >پشتیبانی<img width="20" height="20" src="https://safir.radap.ir/static/img/phone.png" alt="phone" /></div>
        </div>
    </div>
    <div class="container">
      <map-track v-if="coordinates" :coordinates="coordinates" />
    </div>
    <div>وضعیت سفارش : <h5 class="text-danger d-inline-block">{{stateFa}}</h5></div>
  
    <div class="d-flex justify-content-center align-items-center mt-3">
      <div class="progresses mb-2">
        <div class="steps " style="width:35px;height:35px" :class="hasActive(state, 1, 1)">
          <span><i :class="hasActive(state, 1, 2)" style="vertical-align:middle" class="fa fa-spinner"></i></span>
        </div>
        <span class="line"></span>
        <div class="steps " style="width:35px;height:35px" :class="hasActive(state, 2, 1),hasActive(state, 3, 1),hasActive(state, 4, 1)">
          <span><i :class="hasActive(state, 2, 2),hasActive(state, 3, 2),hasActive(state, 4, 2)" style="vertical-align:middle" class="fa fa-archive"></i></span>
        </div>
        <span class="line"></span>
        <div class="steps " style="width:35px;height:35px" :class="hasActive(state, 5, 1)">
          <span><i :class="hasActive(state, 5, 2)" style="vertical-align:middle" class="fa fa-truck"></i></span>
        </div>
        <span class="line"></span>
        <div class="steps " style="width:35px;height:35px" :class="hasActive(state, 6, 1)">
          <span><i :class="hasActive(state, 6, 2)" style="vertical-align:middle" class="fa fa-check"></i></span>
        </div>
      </div>
    </div>
    
  <div v-if="state == 1">
    <div class="small">باتشکر از حسن انتخاب شما</div>
    <h4 class="text-center" v-if="!isExpired && valid == 2">
      <img width="35" height="35" src="https://radap.ir/imagesUploaded/other/clock.gif" alt="clock" />
      <counter-down :time="time" @finishCounter="isExpired = true"/>
    </h4>
  </div>
  <div v-if="state == 2 || state == 3 || state == 4 || state == 5">
    <h4 class="text-center" v-if="!isExpired">
      <img width="35" height="35" src="https://radap.ir/imagesUploaded/other/clock.gif" alt="clock" />
      <counter-down :time="time" @finishCounter="isExpired = true"/>
    </h4>
    <div class="small" v-if="!isExpired">باتشکر از حسن انتخاب شما</div>
    <div v-else style="font-family: 'IranSans';padding: 0.5em;" class="r-text-start mt-2">
      <p style="font-size: 14px;font-weight: 700" class="mb-1">ازتاخیر پیش آمده عذرخواهیم</p>
      <p style="font-size: 14px;" class="mb-0">سفارشتان تا دقایقی دیگر به دستتان خواهد رسید.</p>
    </div>
  </div>
  <div v-if="state == 6">
    <div class="small my-2">امیدواریم از سفارشتان لذت ببرید</div>
    <div class="d-flex justify-content-around align-items-center p-1" v-if="timeTrack > 0">
      <small>سفارش را تحویل نگرفته اید؟</small>
      <a href="tel:05152524850">
        <small class="pe-1 text-dark">تماس بگیرید</small>
        <img width="20" height="20" src="https://safir.radap.ir/static/img/phone.png" alt="phone" />
      </a>
    </div>
  </div>
  <hr />
  <div>
    <div class="small r-text-start r-pr-1 mb-0">با ثبت نظر بعد از اتمام سفارش امتیاز باشگاه مشتریان را دریافت کنید.</div>
    <button type="button" class="btn btn-success mt-2" @click="goPoll">شرکت در نظرسنجی</button>
   <button class="btn btn-transparent border-0 text-primary w-100 mt-3 " style="text-align:center" data-bs-toggle="offcanvas" data-bs-target="#cardoffcanvasBottom" aria-controls="cardoffcanvasBottom"><img src="https://radap.ir/imagesUploaded/card/info.png" width="20" class="ml-1"/>اطلاعات بیشتر درباره امتیازات</button>

  </div>
</div>
<div class="offcanvas offcanvas-bottom" tabindex="-1" id="cardoffcanvasBottom" aria-labelledby="cardoffcanvasBottomLabel" style="z-index: 99999;">
  <div class="offcanvas-header">
    <h6 class="offcanvas-title text-dark" id="cardoffcanvasBottomLabel" style="display: flex;align-items: center;font-weight: 700;"><img src="https://radap.ir/imagesUploaded/card/star.png" width="50">در راداَپ هر امتیازت ارزشمنده!</h6>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body small text-dark">
    <div style="text-align: justify">
      با رسیدن به ۱,۰۰۰ امتیاز کد تخفیف ویژه دریافت کنید به ازای هر ۱,۰۰۰ امتیاز کد تخفیف مخصوص و اختصاصی برای شما ساخته می شود و از طریق پیامک اطلاع رسانی می گردد لازم به ذکر است هر چقدر تعداد ۱,۰۰۰امتیاز شما بالاتر باشد کد تخفیف بزرگتر و متنوع تر خواهد بود یعنی به زبان ساده کد تخفیف ۱,۰۰۰ امتیاز اول با دوم و دوم با سوم متفاوت خواهد بود و هر چه امتیاز شما بالاتر باشد کد تخفیف شما بزرگتر خواهد شد برای دریافت کد تخفیف بعد از رسیدن به ۱,۰۰۰امتیاز اول به پشتیبانی راداَپ از طریق این شماره ۰۹۹۲۸۷۲۸۹۷۱اطلاع رسانی کنید تا در سریعترین زمان ممکن بررسی و کد تخفیف بعد از تایید پشتیبانی راداَپ تقدیم شما گردد.
    </div>
    <button class="btn btn-outline-success text-dark w-100 mt-1 small" type="button" data-bs-dismiss="offcanvas">متوجه شدم</button>
  </div>
</div>
<button id="suppotOffcanvasBTN" data-bs-toggle="offcanvas" data-bs-target="#offcanvasDeliver"  class="d-none"></button>
<div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasDeliver" aria-labelledby="offcanvasDeliverLabel">
  <div class="offcanvas-header">
    <h6 class="offcanvas-title text-dark" id="offcanvasDeliverLabel" style="display: flex;align-items: flex-end;font-weight: 700;">همکاران ما در تلاشند تا سفارش شما هرچه سریع تر به دستتان برسد</h6>
    <!-- <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button> -->
  </div>
  <div class="offcanvas-body small text-dark">
  

    <div class="d-flex justify-content-between mb-2">
        <div>
          <img class="mr-1" width="20" height="20" src="https://radap.ir/imagesUploaded/other/support.png" alt="phone" />
        پشتیبانی راداَپ</div>
        <div>
          <a href="tel:05152524850" class="text-decoration-none">
            <img class="mr-1" width="20" height="20" src="https://safir.radap.ir/static/img/phone.png" alt="phone" />
          </a>
        </div>
      </div>
    <div v-if="deliver" class="d-flex justify-content-between mb-2">
        <div>
          <svg class="mr-1" width="1.25rem" height="1.25rem" viewBox="0 0 20 20" fill="#676A70" xmlns="http://www.w3.org/2000/svg"><path data-v-402533ec="" d="M14.5832 9.58325C14.1229 9.58325 13.7498 9.95635 13.7498 10.4166C13.7498 10.8768 14.1229 11.2499 14.5832 11.2499C15.0434 11.2499 15.4165 10.8768 15.4165 10.4166C15.4165 9.95635 15.0434 9.58325 14.5832 9.58325Z"></path><path data-v-402533ec="" fill-rule="evenodd" clip-rule="evenodd" d="M7.55167 17.6256C5.58545 18.4597 3.42815 17.2569 2.99477 15.2849L2.80188 15.3599C2.54548 15.4596 2.25639 15.4264 2.02933 15.2711C1.80228 15.1157 1.6665 14.8584 1.6665 14.5833L1.6665 9.16659C1.6665 6.62223 2.7184 4.66703 4.31719 3.36431C5.89569 2.07812 7.96582 1.45825 9.99984 1.45825C12.0339 1.45825 14.104 2.07812 15.6825 3.36431C17.2813 4.66703 18.3332 6.62223 18.3332 9.16659V12.4999C18.3332 12.8344 18.1332 13.1364 17.8253 13.2671L7.55167 17.6256ZM9.90247 7.08896L3.45858 7.84706C3.73253 6.47175 4.43547 5.41782 5.36998 4.65636C6.60398 3.65088 8.28385 3.12492 9.99984 3.12492C11.7158 3.12492 13.3957 3.65088 14.6297 4.65636C15.8434 5.64531 16.6665 7.12761 16.6665 9.16659V11.9482L6.90075 16.0913C5.83543 16.5432 4.65792 15.7992 4.58658 14.6659L10.3019 12.4433C10.6222 12.3187 10.8332 12.0103 10.8332 11.6666V7.91659C10.8332 7.67861 10.7314 7.45199 10.5536 7.29386C10.3758 7.13572 10.1388 7.06115 9.90247 7.08896ZM9.1665 11.0965L3.33317 13.365L3.33317 9.53998L9.1665 8.85371L9.1665 11.0965Z"></path></svg>
          {{deliver}}</div>
        <div>
          <a :href="'tel:'+deliverPhone" class="text-decoration-none">
            <img class="mr-1" width="20" height="20" src="https://safir.radap.ir/static/img/phone.png" alt="phone" />
          </a>
        </div>
    </div>
    <button class="btn btn-outline-dark text-dark w-100 mt-2 ml-1" type="button" data-bs-dismiss="offcanvas">بستن</button>
  </div>
</div>
<div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasOrderItems" aria-labelledby="offcanvasOrderItemsLabel">
  <div class="offcanvas-header">
    <h6 class="offcanvas-title text-dark" id="offcanvasOrderItemsLabel" style="display: flex;align-items: flex-end;font-weight: 700;">جزئیات سفارش : </h6>
  </div>
  <div class="offcanvas-body small text-dark" v-if="order">
    
    <table class="table table-striped table-hover table-bordered">
    <thead>
      <tr>
        <th>نام</th>
        <th>قیمت</th>
        <th>تعداد</th>
        <th>تخفیف</th>
        <th>قیمت نهایی</th>
      </tr>
    </thead>
    <tbody>
    <tr v-for="(item,index) in order.items" :key="item.id">
      <td><img :src="'https://radap.ir/'+item.img_url.split(',')[0]" width="30" height="30" /> 
      <span>
      {{ item.name }}
      </span>
      <small class=" text-muted">{{item.description}}</small>
      </td>
      <td>{{ convertToPersian(String(numberFormat(item.prime_price))) }} </td>
      <td>{{ convertToPersian(String(item.quantity)) }}</td>
      <td>{{ convertToPersian(String(item.discount)) }} <span v-if="item.discount > 0">%</span></td>
      <td>{{ convertToPersian(String(numberFormat(item.price * item.quantity))) }} </td>
    </tr>
    </tbody>
    </table>
    <div>آدرس : </div>
    <div>{{ order.address }}</div>
    <hr />
    <div>توضیحات : </div>
    <div>{{ order.description }}</div>
    <hr />
    <div class="d-flex justify-content-between">
        <div>جمع صورتحساب :</div>
        <div>{{ convertToPersian(numberFormat(order.amount.raw_amount)) }} تومان</div>
    </div>
    <div class="d-flex justify-content-between"  v-if="order.amount.delivery > 0">
      <div>پیک : </div>
      <div>{{ convertToPersian(numberFormat(order.amount.delivery)) }} تومان</div>
    </div>
    <div class="d-flex justify-content-between"  v-if="order.amount.discount > 0">
        <div>سود شما : </div>
        <div>{{ convertToPersian(numberFormat(order.amount.discount)) }} تومان</div>
    </div>
    <div class="d-flex justify-content-between" v-if="order.amount.wallet > 0">
        <div>کیف پول :</div>
        <div>{{ convertToPersian(numberFormat(order.amount.wallet)) }} تومان</div>
    </div>
    <div class="d-flex justify-content-between" v-if="order.amount.amount">
        <div>مبلغ نهایی : </div>
        <div class="text-success">{{ convertToPersian(numberFormat(order.amount.amount)) }} تومان</div>
    </div>
    
    <button class="btn btn-outline-dark text-dark w-100 mt-2 ml-1" type="button" data-bs-dismiss="offcanvas">بستن</button>
  </div>
</div>
<!--  <grid-template /> -->
<footer-template />
</template>

<script setup>
import HeaderMiddle from '../section/header/header.vue';
import FooterTemplate from "../section/footer/footer.vue";
import MapTrack from "@/components/section/item/MapTrack.vue"
import { ref,onMounted,onUnmounted } from "vue";
import { useRoute,useRouter } from "vue-router";
import { convertToPersian, numberFormat } from '@/composables/digits';
import CounterDown from '@/composables/counterDown.vue'
import { alertBox } from '@/composables/silverBox';
let route = useRoute();
let router = useRouter();
let state = ref();
let valid = ref();
let time = ref(0);
let timeTrack = ref(0);
let logCode = ref('');
let deliver = ref();
let deliverPhone = ref();
let orderDate = ref('');
let order = ref();
let coordinates = ref();
let isExpired = ref();
let stateFa = ref();
let getStateTrackInterval;
getState()
onMounted(() => {
  getStateTrackInterval = setInterval(getState, 10000);
});
onUnmounted(() => {
  clearInterval(getStateTrackInterval) 
});
async function getState() {
    let response = await fetch("https://radap.ir/Backend/api/section/track/getState.php?pre_id="+route.params.id)
    let data = await response.json()
    state.value = data.state;
    valid.value = data.valid;
    stateFa.value = data.state_fa;
    deliver.value = data.deliver;
    deliverPhone.value = data.deliverPhone;
    order.value = data.order;
    orderDate.value = data.time;
    logCode.value = data.log_code;
    time.value = data.time_expire;
    coordinates.value = data.coordinates;
    timeTrack.value = data.time_track;
    isExpired.value = data.expire;
}
function hasActive(state, child, type) {
  if (type == 1) {
    if (child == state) {
      return "my-active";
    }
  } else if (type == 2) {
    if (child == state) {
      return " ";
    }
  }
}
async function goPoll(){
  await getState()
  if(state.value == 6){
    router.push({name:'Poll',params:{id:route.params.id}})
  }else{
    alertBox("فقط بعد از تحویل سفارش میتوانید در نظر سنجی شرکت کنید")
  }
}
function goSupport(){
  if(state.value < 6){
    document.getElementById('suppotOffcanvasBTN').click()
  }else{
    alertBox('سفارش شما به اتمام رسیده است.')
  }
}
</script>
<style scoped>
.my-active {
  background-color: #245def !important;
}

.progresses {
  display: flex;
  align-items: center;
}

.line {
  width: 40px;
  height: 6px;
  background: #c4ebd9;
}

.progress {
  height: 25px;
}

.steps {
  display: flex;
  background-color: #c4ebd9;
  color: #fff;
  font-size: 14px;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.r-text-start{
  text-align: start;
}
.r-pr-1{
  padding-right: .5em;
}
@media (min-width : 576px){
  .r-text-start{
    text-align: center;
  }
  .r-pr-1{
    padding-right: 0;
  }
}
</style>
